import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import React from "react";

export default function TextModal({ title, text, ...props }) {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {text.map((item, index) => (
          <div
            key={index}
            dangerouslySetInnerHTML={{
              __html: item,
            }}
          ></div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
